export default __webpack_public_path__ + "static/media/shopify-logo.db4fbdb0.webp";